import React, { Component } from "react";
import { Doughnut } from "react-chartjs-2";
import { tranStr } from "../../utils/translation";
import isEmpty from "../../validation/is-empty";
import PropTypes from "prop-types";

import { Legend } from "./EstimatesBenchmarkDonutChart.components";
import "./EstimatesBenchmarkDonutChart.css";

export default class EstimatesBenchmarkDonutChart extends Component {
  render() {
    const { data, data2, projectName, benchmarks, thisBenchmark } = this.props;

    let labels = [projectName, "Benchmark Average"];
    let field = [];
    let value = [];
    let value2 = [];
    let percentages = [[], []];

    data.forEach((d, i) => {
      // If the comparison dataset has a matching section
      if (d !== undefined && !isEmpty(data2[i])) {
        field.push(d.name);
        value.push(d.quantity);
        value2.push(data2[i].quantity);
        percentages[0].push(d.percentage);
        percentages[1].push(data2[i].percentage);
      }

      // If the comparison dataset does not have a matching section
      if (d !== undefined && isEmpty(data2[i])) {
        field.push(d.name);
        value.push(d.quantity);
        value2.push(0);
        percentages[0].push(d.percentage);
        percentages[1].push(0);
      }
    });

    // Colours
    let heritage = "rgba(228, 97, 15, 1)";

    let aqua = "rgba(50, 98, 149, 1)";
    let collaboration1 = "rgba(85, 87, 90, 1)";
    let heritage2 = "rgba(228, 97, 15, 0.5)";
    let aqua2 = "rgba(50, 98, 149, 0.5)";
    let collaboration2 = "rgba(85, 87, 90, 0.7)";
    let collaboration3 = "rgba(85, 87, 90, 0.3)";
    let built1 = "rgba(245, 199, 103, 1)";
    let built2 = "rgba(248, 218, 154, 1)";
    let natural1 = "rgba(64, 150, 153, 1)";
    let natural2 = "rgba(128, 185, 187, 1)";
    let strength1 = "rgba(181,92,146,1)";
    let strength2 = "rgba(206, 147, 183, 1)";

    let colours = [
      heritage,
      aqua,
      collaboration1,
      aqua2,
      heritage2,
      collaboration2,
      collaboration3,
      natural1,
      built1,
      strength2,
      built2,
      natural2,
      strength1,
    ];

    // Create the graph object
    let graph = {
      labels: field,
      datasets: [
        {
          label: tranStr("Project"),
          data: value,
          barThickness: 10,
          backgroundColor: colours,
        },
        {
          label: tranStr("Benchmark"),
          data: value2,
          barThickness: 10,
          backgroundColor: colours,
        },
      ],
      text: field,
    };

    // Create the options object
    let options = {
      plugins: {
        datalabels: {
          display: false,
          color: "gray",
          formatter: function (tick, context) {
            return percentages[context.datasetIndex][context.dataIndex] + "%";
          },
        },
      },
      cutoutPercentage: 70,
      animation: {
        duration: 2000,
      },
      tooltips: {
        enabled: true,
        xPadding: 10,
        yPadding: 10,
        callbacks: {
          label: function (tooltipItem, chart) {
            return (
              labels[tooltipItem.datasetIndex] +
              " | " +
              chart.labels[tooltipItem.index] +
              " | " +
              percentages[tooltipItem.datasetIndex][tooltipItem.index] +
              "%"
            );
          },
        },
      },
      layout: {
        padding: {},
      },
      legend: {
        display: false,
        align: "start",
        position: "bottom",
        fullWidth: false,
        reverse: false,
        labels: {
          usePointStyle: true,
        },
      },
    };

    return (
      <div className="estimate-dashboard">
        {!isEmpty(benchmarks) && (
          <div className="legend-project-label">{tranStr("Project")}</div>
        )}
        {!isEmpty(benchmarks) && (
          <div className="legend-benchmark-label">
            {tranStr("Benchmark Avg")}
          </div>
        )}
        {!isEmpty(benchmarks) && (
          <svg className="legend-svg1">
            <polyline className="legend-svg-line1" points="7,40 50,40 70,60" />
          </svg>
        )}
        {!isEmpty(benchmarks) && (
          <svg className="legend-svg2">
            <polyline
              className="legend-svg-line2"
              points="143,20 20,20 0,0  "
            />
          </svg>
        )}
        <div className="estimate-construction-cost-comparison">
          <Doughnut data={graph} options={options} height={160} />
        </div>
        <Legend data={data} colours={colours} thisBenchmark={thisBenchmark} />
      </div>
    );
  }
}
EstimatesBenchmarkDonutChart.propTypes = {
  data: PropTypes.array,
};
